export {default as hexbin} from "./src/hexbin";



//////////////////
// WEBPACK FOOTER
// ./~/d3-hexbin/index.js
// module id = 365
// module chunks = 0